/*
---------------------------------------------------
Funciones para compra overlay
---------------------------------------------------
*/

// Ocultar todos compra overlay abiertos en el DOM
function ocultarTodosOverlays() {
  document.querySelectorAll(".overlay-sobre-producto").forEach(overlay => {
      overlay.style.display = "none";
  });
}

// Funciones para estilos dinamicos en compra overlay
function resetStylesCompraUnica(compraUnica) {
  compraUnica.style.backgroundColor = "";
  compraUnica.style.border = "solid rgb(0 0 0 / 30%)";
  compraUnica.style.borderWidth = "2px 2px 0px 2px";
  compraUnica.style.borderRadius = "4px 4px 0px 0px";
  compraUnica.style.padding = "24px 12px";
}

function resetStylesSubscripcion(compraSubscripcion) {
  compraSubscripcion.style.backgroundColor = "";
  compraSubscripcion.style.border = "solid rgb(0 0 0 / 30%)";
  compraSubscripcion.style.borderWidth = "0px 2px 2px 2px";
  compraSubscripcion.style.borderRadius = "0px 0px 4px 4px";
  compraSubscripcion.style.padding = "24px 12px";
}

function activarStylesCompraUnica(container) {
  const compraUnica = container.querySelector("#div_compra_unica");
  const compraSuscripcion = container.querySelector("#compra-subscripcion");
  const subscriptionOptions = container.querySelector("#subscription-options");
  const btnComprar = container.querySelector("#btn-comprar");

  resetStylesSubscripcion(compraSuscripcion);

  compraUnica.style.backgroundColor = "rgb(255,245,237)";
  compraUnica.style.border = "2px solid #FFD54F";
  compraUnica.style.borderRadius = "4px 4px 0px 0px";
  btnComprar.textContent = "Agregar producto";
  btnComprar.style.display = "block";

  if (subscriptionOptions){
      subscriptionOptions.style.display = "none";
      subscriptionOptions.querySelector('input[type="radio"][value="1"]').checked = false;
  } 
}

function activarStylesSuscripcion(container) {
  const compraUnica = container.querySelector("#div_compra_unica");
  const compraSuscripcion = container.querySelector("#compra-subscripcion");
  const subscriptionOptions = container.querySelector("#subscription-options");
  const btnComprar = container.querySelector("#btn-comprar");

  resetStylesCompraUnica(compraUnica);

  compraSuscripcion.style.backgroundColor = "rgb(255,245,237)";
  compraSuscripcion.style.border = "solid #FFD54F";
  compraSuscripcion.style.borderWidth = "2px 2px 0px 2px";
  compraSuscripcion.style.padding = "24px 12px 0px 12px";
  compraSuscripcion.style.borderRadius = "0px 0px 0px 0px";
  btnComprar.textContent = "Agregar suscripción";
  btnComprar.style.display = "block";

  if (subscriptionOptions){
      subscriptionOptions.style.display = "flex";
      subscriptionOptions.querySelector('input[type="radio"][value="1"]').checked = true;
  } 
}

// Mostrar el compra overlay
function abrirCompraOverlay(event) {
  if (event.target.id === "ver-producto-button") {
    event.preventDefault();
    ocultarTodosOverlays();
  
    const productWrapper = event.target.closest('.t4s-product-wrapper');
    productWrapper.style.position = "relative"

    const overlay = productWrapper.querySelector('.overlay-sobre-producto');

    if (overlay) {
      document.removeEventListener('click', handleClickOutsideOverlay);

      const compraUnicaRadioBtn = overlay.querySelector(".compra-unica-radiobtn-overlay");
      const compraSuscripcionRadioBtn = overlay.querySelector(".compra-suscripcion-radiobtn-overlay");
      const btnCerrar = overlay.querySelector(".close-overlay-button");

      compraUnicaRadioBtn.addEventListener("click", () => activarStylesCompraUnica(overlay));
      compraSuscripcionRadioBtn.addEventListener("click", () => activarStylesSuscripcion(overlay));
      btnCerrar.addEventListener("click", ocultarTodosOverlays);

      const currentPath = window.location.pathname;
      const targetCollection = 'savvy-prime-productos-suscripcion';

      if(currentPath.includes(targetCollection)){
        compraSuscripcionRadioBtn.checked = true;
        if(compraSuscripcionRadioBtn.checked){
          activarStylesSuscripcion(overlay);
        }
      }else{
        overlay.querySelector('[class*="subscription-price-"]').value = "";
        overlay.querySelector('[class*="subscription-discount-"]').value = "";

        compraUnicaRadioBtn.checked = "true";
        if(compraUnicaRadioBtn.checked){
          activarStylesCompraUnica(overlay);
        }
      }

      overlay.style.display = 'block';

      // Asignacion de evento para cerrar overlays
      overlay.currentProductWrapper = productWrapper;

      function handleClickOutsideOverlay(event) {
        const activeOverlay = document.querySelector('.overlay-sobre-producto[style="display: block;"]');
        if (activeOverlay && activeOverlay.currentProductWrapper && 
            !activeOverlay.currentProductWrapper.contains(event.target)) {
          ocultarTodosOverlays();
        }
      }

      document.addEventListener('click', handleClickOutsideOverlay);

      // Manejo de click en cartas del overlay para activar radiobtn
      const divCompraUnica = overlay.querySelectorAll('#div_compra_unica');
      const divSuscripcion = overlay.querySelectorAll('#compra-subscripcion');
    
      if (divCompraUnica.length === 0) {
        console.error('No se encontró ningún div con clase .div_compra_unica');
      } else {
        divCompraUnica.forEach(div => {
        const radioButton = div.querySelector('.compra-unica-radiobtn-overlay');
        if (radioButton) {
          div.addEventListener('click', () => radioButton.click());
        } else {
          console.error('No se encontró el radio button .compra-unica-radiobtn-overlay dentro del div .div_compra_unica');
        }
        });
      }
    
      if (divSuscripcion.length === 0) {
        console.error('No se encontró ningún div con clase .compra-subscripcion');
      } else {
        divSuscripcion.forEach(div => {
        const radioButtonSuscripcion = div.querySelector('.compra-suscripcion-radiobtn-overlay');
        if (radioButtonSuscripcion) {
          div.addEventListener('click', () => radioButtonSuscripcion.click());
        } else {
          console.error('No se encontró el radio button .compra-suscripcion-radiobtn-overlay dentro del div .compra-subscripcion');
        }
        });
      }

    }
  }
}

document

/*
---------------------------------------------------
Funciones para sidebar de suscripcion
---------------------------------------------------
*/

// Ocultar todos sidebar abiertos en el DOM
function ocultarTodosSidebar() {
  document.querySelectorAll(".overlay-suscripcion-sidebar").forEach(overlay => {
      overlay.style.display = "none";
  });
}

// Funciones para estilos dinamicos en sidebar suscripcion
function resetStylesCompraUnicaSidebar(compraUnica) {
  compraUnica.style.backgroundColor = "";
  compraUnica.style.border = "solid rgb(0 0 0 / 30%)";
  compraUnica.style.borderWidth = "2px 2px 0px 2px";
  compraUnica.style.borderRadius = "4px 4px 0px 0px";
  compraUnica.style.padding = "24px 12px";
}

function resetStylesSubscripcionSidebar(compraSubscripcion) {
  compraSubscripcion.style.backgroundColor = "";
  compraSubscripcion.style.border = "solid rgb(0 0 0 / 30%)";
  compraSubscripcion.style.borderWidth = "0px 2px 2px 2px";
  compraSubscripcion.style.borderRadius = "0px 0px 4px 4px";
  compraSubscripcion.style.padding = "24px 12px";
}

function activarStylesCompraUnicaSidebar(container) {
  const compraUnica = container.querySelector("#div_compra_unica11");
  const compraSuscripcion = container.querySelector("#compra-subscripcion11");
  const subscriptionOptions = container.querySelector("#subscription-options1");
  const btnComprar = container.querySelector("#btn-comprar11");

  resetStylesSubscripcionSidebar(compraSuscripcion);

  compraUnica.style.backgroundColor = "rgb(255,245,237)";
  compraUnica.style.border = "2px solid #FFD54F";
  compraUnica.style.borderRadius = "4px 4px 0px 0px";
  btnComprar.textContent = "Agregar producto";
  btnComprar.style.display = "block";

  if (subscriptionOptions){
      subscriptionOptions.style.display = "none";
      subscriptionOptions.querySelector('input[type="radio"][value="1"]').checked = false;
  } 
}

function activarStylesSuscripcionSidebar(container) {
  const compraUnica = container.querySelector("#div_compra_unica11");
  const compraSuscripcion = container.querySelector("#compra-subscripcion11");
  const subscriptionOptions = container.querySelector("#subscription-options1");
  const btnComprar = container.querySelector("#btn-comprar11");

  resetStylesCompraUnicaSidebar(compraUnica);

  compraSuscripcion.style.backgroundColor = "rgb(255,245,237)";
  compraSuscripcion.style.border = "2px solid #FFD54F";
  compraSuscripcion.style.borderWidth = "2px 2px 0px 2px";
  compraSuscripcion.style.padding = "24px 12px 0px 12px"
  compraSuscripcion.style.borderRadius = "0px 0px 0px 0px";
  btnComprar.textContent = "Agregar suscripción";
  btnComprar.style.display = "block";

  if (subscriptionOptions){
      subscriptionOptions.style.display = "flex";
      subscriptionOptions.querySelector('input[type="radio"][value="1"]').checked = true;
  } 
}

// Mostrar el sidebar de suscripcion
function abrirSuscripcionSidebar(event){
  const productContainer = event.target.closest('[class^="t4s-product t4s-pr-grid"]');

  if(productContainer){
    const suscripcionSidebar = productContainer.querySelector(".overlay-suscripcion-sidebar");
    
    if(suscripcionSidebar){
      document.removeEventListener('click', handleClickOutsideSidebar);

      const compraUnicaRadioBtnSidebar = suscripcionSidebar.querySelector(".compra-unica-radiobtn-sidebar");
      const compraSuscripcionRadioBtnSidebar = suscripcionSidebar.querySelector(".compra-suscripcion-radiobtn-sidebar");
      const closeSidebarBtn = suscripcionSidebar.querySelector(".t4s-drawer__close");

      compraUnicaRadioBtnSidebar.addEventListener("click", () => activarStylesCompraUnicaSidebar(suscripcionSidebar));
      compraSuscripcionRadioBtnSidebar.addEventListener("click", () => activarStylesSuscripcionSidebar(suscripcionSidebar));
      closeSidebarBtn.addEventListener("click", ocultarTodosSidebar);

      compraSuscripcionRadioBtnSidebar.checked = "true";
      if(compraSuscripcionRadioBtnSidebar){
        activarStylesSuscripcionSidebar(suscripcionSidebar);
      }

      suscripcionSidebar.style.display = "block";

      // Asignacion de eventos para cerrar sidebar
      suscripcionSidebar.currentProductContainer = productContainer;
      
      function handleClickOutsideSidebar(event) {
        const activeSidebar = document.querySelector('.overlay-suscripcion-sidebar[style="display: block;"]');
        if (activeSidebar && activeSidebar.currentProductContainer && !activeSidebar.currentProductContainer.contains(event.target) || event.target == suscripcionSidebar) {
          ocultarTodosSidebar();
        }
      }

      document.addEventListener('click', handleClickOutsideSidebar);
    }
  }
  
}

document.addEventListener("DOMContentLoaded", function () {
  const divCompraUnica = document.querySelectorAll('#div_compra_unica');
  const divSuscripcion = document.querySelectorAll('#compra-subscripcion');

  if (divCompraUnica.length === 0) {
      console.error('No se encontró ningún div con clase .div_compra_unica');
  } else {
      divCompraUnica.forEach(div => {
      const radioButton = div.querySelector('.compra-unica-radiobtn-overlay');
      if (radioButton) {
          div.addEventListener('click', () => radioButton.click());
      } else {
          console.error('No se encontró el radio button .compra-unica-radiobtn-overlay dentro del div .div_compra_unica');
      }
      });
  }

  if (divSuscripcion.length === 0) {
      console.error('No se encontró ningún div con clase .compra-subscripcion');
  } else {
      divSuscripcion.forEach(div => {
      const radioButtonSuscripcion = div.querySelector('.compra-suscripcion-radiobtn-overlay');
      if (radioButtonSuscripcion) {
          div.addEventListener('click', () => radioButtonSuscripcion.click());
      } else {
          console.error('No se encontró el radio button .compra-suscripcion-radiobtn-overlay dentro del div .compra-subscripcion');
      }
      });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const divCompraUnica = document.querySelectorAll('#div_compra_unica11');
  const divSuscripcion = document.querySelectorAll('#compra-subscripcion11');

  if (divCompraUnica.length === 0) {
      console.error('No se encontró ningún div con clase .div_compra_unica');
  } else {
      divCompraUnica.forEach(div => {
      const radioButton = div.querySelector('.compra-unica-radiobtn-sidebar');
      if (radioButton) {
          div.addEventListener('click', () => radioButton.click());
      } else {
          console.error('No se encontró el radio button .compra-unica-radiobtn-overlay dentro del div .div_compra_unica');
      }
      });
  }

  if (divSuscripcion.length === 0) {
      console.error('No se encontró ningún div con clase .compra-subscripcion');
  } else {
      divSuscripcion.forEach(div => {
      const radioButtonSuscripcion = div.querySelector('.compra-suscripcion-radiobtn-sidebar');
      if (radioButtonSuscripcion) {
          div.addEventListener('click', () => radioButtonSuscripcion.click());
      } else {
          console.error('No se encontró el radio button .compra-suscripcion-radiobtn-overlay dentro del div .compra-subscripcion');
      }
      });
  }
  });